"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuth0Instance = exports.initAuth0 = void 0;
const auth0_spa_js_1 = require("@auth0/auth0-spa-js");
let instance = null;
const createInstance = async (options) => {
    let isInitialized = false;
    let instance;
    try {
        instance = await (0, auth0_spa_js_1.default)(options);
        isInitialized = true;
    }
    catch (e) {
        console.error('Auth0: Initialization error');
    }
    return {
        isInitialized,
        async loginWithPopup() {
            try {
                await instance.loginWithPopup();
                return instance.isAuthenticated();
            }
            catch (e) {
                return false;
            }
        },
        async loginWithRedirect(options) {
            return instance.loginWithRedirect(options);
        },
        async handleRedirectCallback() {
            return instance.handleRedirectCallback();
        },
        async logout(logoutOptions) {
            return instance.logout(logoutOptions);
        },
        async isAuthenticated() {
            return instance.isAuthenticated();
        },
        async getToken(options, usePopup = false, throwException = false) {
            try {
                if (usePopup) {
                    return await instance.getTokenWithPopup(options);
                }
                return await instance.getTokenSilently(options);
            }
            catch (e) {
                if (throwException) {
                    throw e;
                }
                return null;
            }
        }
    };
};
const initAuth0 = async (options) => {
    instance = await createInstance(options);
};
exports.initAuth0 = initAuth0;
const getAuth0Instance = () => instance;
exports.getAuth0Instance = getAuth0Instance;
